import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';

interface SearchProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  placeholder?: string;
  icon?: React.ReactNode;
  inputClassName?: string;
}

interface CollapsiblePanelProps {
  title: string;
  collapsed: boolean;
  onToggleCollapse: () => void;
  searchProps?: SearchProps;
  children: React.ReactNode;
  panelClassName?: string;
}

const CollapsiblePanel: React.FC<CollapsiblePanelProps & { selectedDept?: string | null, selectedSubdept?: string | null }> = ({
  title,
  collapsed,
  onToggleCollapse,
  searchProps,
  children,
  panelClassName,
  selectedDept,
  selectedSubdept,
}) => {
  const [isMobile, setIsMobile] = React.useState(false);
  React.useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 600);
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);
  return (
    <div className={panelClassName}>
      {isMobile ? (
        <div className="collapsible-collapsed-row">
          <span className="collapsible-vertical-label">{title}</span>
          <button
            className="collapsible-toggle-btn"
            onClick={onToggleCollapse}
            aria-label="Open Menu"
          >
            {FaChevronRight({ size: 18 })}
          </button>
          {(selectedDept || selectedSubdept) && (
            <span className="selected-dept-label">
              {selectedSubdept ? selectedSubdept : ''}
            </span>
          )}
        </div>
      ) : collapsed ? (
        <div className="collapsible-collapsed">
          <div className="collapsible-collapsed-row">
            <span className="collapsible-vertical-label">{title}</span>
            <button
              className="collapsible-toggle-btn"
              onClick={onToggleCollapse}
              aria-label="Expand"
            >
              {FaChevronRight({ size: 18 })}
            </button>
          </div>
        </div>
      ) : (
        <>
          <div className="collapsible-header">
            <div className="collapsible-title">{title}</div>
            <button
              className="collapsible-toggle-btn"
              onClick={onToggleCollapse}
              aria-label="Collapse"
            >
              {FaChevronLeft({ size: 18 })}
            </button>
          </div>
          {searchProps && (
            <div className="collapsible-search-row">
              <span className="collapsible-search-icon">{searchProps.icon}</span>
              <input
                className={searchProps.inputClassName ? `${searchProps.inputClassName} collapsible-search-input` : 'collapsible-search-input'}
                type="text"
                placeholder={searchProps.placeholder || 'Search'}
                value={searchProps.value}
                onChange={searchProps.onChange}
              />
            </div>
          )}
          {children}
        </>
      )}
    </div>
  );
};

export default CollapsiblePanel; 